import { EAnalyticsFieldName } from '../../constants';
import { TOfferType } from '../../types';
import { ITrackUserInput } from './getUserInput';

export enum ETypeChangeInput {
  AUTO = 'auto',
  MANUAL = 'manual',
}

export interface IOfferForAnalytic {
  name: string;
  description: string;
  psk: string | number | null;
  rate: number | string;
  payment: number;
  type: TOfferType;
}

export interface ITrackFunctionParams {
  event?: string;
  ec?: string;
  ea: 'newpage' | 'click' | 'show' | 'change' | 'success';
  el: string;
  extra?:
    | Record<string, string | number | undefined | null | IOfferForAnalytic[]>
    | IExtraForOffersList
    | IExtraForOffers
    | IExtraForAnketaModal;
}

interface IExtraForOffersList {
  offer_params: IOfferForAnalytic;
  list_number: number;
}

interface IExtraForOffers {
  offer_params: IOfferForAnalytic | null;
}

interface IExtraForAnketaModal {
  offer_params: IOfferForAnalytic | null;
  userInput: ITrackUserInput;
  list_number: number | null;
}

export interface ITrackAnketaModalProps {
  offer: IOfferForAnalytic | null;
  userInput: ITrackUserInput;
  listNumber: number | null;
}

export interface ITrackFieldValuesProps {
  el: EAnalyticsFieldName;
  paramInput: ETypeChangeInput;
  paramValue: number | string;
}

export interface ITrackClickOnOfferProps {
  listNumber: number;
  offerParams: IOfferForAnalytic;
}

export interface ITrackShowModalProps {
  offer: IOfferForAnalytic;
}

export interface ITrackClickButtonInModalProps {
  offer: IOfferForAnalytic | null;
}

export interface ITrackShowOffers {
  offersList: IOfferForAnalytic[];
}
